import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPathwaysIcon = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 20,
	viewBox: "0 0 22 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.50406 4.38571C4.889 4.00076 5.10526 3.47867 5.10526 2.93428C5.10526 2.38989 4.889 1.86779 4.50406 1.48285C4.11912 1.0979 3.59702 0.881645 3.05263 0.881645C2.50824 0.881645 1.98614 1.0979 1.6012 1.48285C1.21626 1.86779 1 2.38989 1 2.93428C1 3.47867 1.21626 4.00076 1.6012 4.38571C1.98614 4.77065 2.50824 4.98691 3.05263 4.98691C3.59702 4.98691 4.11912 4.77065 4.50406 4.38571Z",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.50406 11.7585C4.889 11.3735 5.10526 10.8514 5.10526 10.307C5.10526 9.76263 4.889 9.24054 4.50406 8.8556C4.11912 8.47065 3.59702 8.25439 3.05263 8.25439C2.50824 8.25439 1.98614 8.47065 1.6012 8.8556C1.21626 9.24054 1 9.76263 1 10.307C1 10.8514 1.21626 11.3735 1.6012 11.7585C1.98614 12.1434 2.50824 12.3597 3.05263 12.3597C3.59702 12.3597 4.11912 12.1434 4.50406 11.7585Z",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.50406 18.5171C4.889 18.1322 5.10526 17.6101 5.10526 17.0657C5.10526 16.5213 4.889 15.9992 4.50406 15.6143C4.11912 15.2293 3.59702 15.0131 3.05263 15.0131C2.50824 15.0131 1.98614 15.2293 1.6012 15.6143C1.21626 15.9992 1 16.5213 1 17.0657C1 17.6101 1.21626 18.1322 1.6012 18.5171C1.98614 18.9021 2.50824 19.1183 3.05263 19.1183C3.59702 19.1183 4.11912 18.9021 4.50406 18.5171Z",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.8421 13.4912L21 10.3333M21 10.3333L17.8421 7.17542M21 10.3333L5.21048 10.3333",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.364 3.01757H11.4736V16.9825H5.364",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgPathwaysIcon);
export default ForwardRef;
